import React from "react";
import Support from "../home/Support";
import ContactInfo from "./ContactInfo";

function Contact() {
  return (
    <div>
      <ContactInfo />
      <Support />
    </div>
  );
}

export default Contact;
